/* eslint-disable react/prop-types */
import classes from "./composed-view-seven.module.scss";
import Label from "@/components-library/widgets/label";
import Flex from "@/components-library/layout/flex";
import Grid from "@/components-library/layout/grid";
import CardViewListStep from "@/composed-views/card-view-list-step";
import classNames from "classnames";
function ComposedViewSeven({ header, title, content, steps, className }) {
  const numberOfRaws = Math.trunc(steps.length / 2) + (steps.length % 2);
  return (
    <Flex
      align="flex-start"
      direction="column"
      justify="flex-start"
      className={classNames(classes.container, className)}
    >
      {header && (
        <Label
          weight="bold"
          tag="h5"
          color="primary"
          align="start"
          className={classes.header}
        >
          {header}
        </Label>
      )}

      {title && (
        <Label
          weight="bold"
          tag="h2"
          color="secondary"
          align="start"
          className={classes.title}
        >
          {title}
        </Label>
      )}

      {content && (
        <Label align="start" size="md" color="secondary">
          {content}
        </Label>
      )}

      {[...Array(numberOfRaws)].map((_, rawIndex) => (
        <Grid columns="1fr 1fr" className={classes.row} key={`raw_${rawIndex}`}>
          <CardViewListStep step={steps[rawIndex + 1 * rawIndex]} />
          <CardViewListStep step={steps[rawIndex + 1 * rawIndex + 1]} />
        </Grid>
      ))}
    </Flex>
  );
}

export default ComposedViewSeven;
